import { render, staticRenderFns } from "./monthlyPlafon.vue?vue&type=template&id=4cb0f27e&"
import script from "./monthlyPlafon.vue?vue&type=script&lang=js&"
export * from "./monthlyPlafon.vue?vue&type=script&lang=js&"
import style0 from "./monthlyPlafon.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports